import React, { useEffect, useState } from 'react';
import classes from './heroSection.module.css';
import { getImageUrl } from '../../../utils/imageUrl';

const HeroSection = (props) => {
    const [offsetY, setOffsetY] = useState(0);

    const handleScroll = () => {
        setOffsetY(window.scrollY);
    };

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <div className={classes.HeroSection}>
            <div 
                className={classes.MainBanner}
                dangerouslySetInnerHTML={{ __html: props.heroSection?.main_banner}}
            />
            <div 
                className={classes.SubBanner}
                dangerouslySetInnerHTML={{ __html: props.heroSection?.sub_banner}}
            />
            <div 
                className={classes.HeroImage} 
                style={{backgroundImage: `url(${getImageUrl(props.heroSection?.banner_image)})`}}
            />
        </div>
    )
}

export default HeroSection;